import React from 'react';
import UserWelcome from 'features/utilisateurs/components/UserPageWelcome';

type Props = {};

const UserWelcomePage: React.FC<Props> = () => {
    return (
        <>
            <UserWelcome></UserWelcome>
        </>
    );
};

export default UserWelcomePage;
